// Shared section color mapping for Form Builder and Form Renderer
// This ensures consistent colors across the application

export const getSectionColorHex = (colorKey: string): string => {
  const colorMap: Record<string, string> = {
    // Primary & Brand Colors
    'primary': '#1fa192',        // primary-500
    'primary-light': '#38bdac',  // primary-400
    'primary-dark': '#0f7f75',   // primary-600
    
    // Blues
    'blue': '#3b82f6',           // blue-500
    'blue-light': '#60a5fa',     // blue-400
    'blue-dark': '#2563eb',      // blue-600
    'sky': '#0ea5e9',            // sky-500
    'sky-light': '#38bdf8',      // sky-400
    'cyan': '#06b6d4',           // cyan-500
    'cyan-light': '#22d3ee',     // cyan-400
    
    // Purples & Violets
    'indigo': '#6366f1',         // indigo-500
    'indigo-light': '#818cf8',   // indigo-400
    'purple': '#a855f7',         // purple-500
    'purple-light': '#c084fc',   // purple-400
    'violet': '#8b5cf6',         // violet-500
    'violet-light': '#a78bfa',   // violet-400
    
    // Pinks & Roses
    'pink': '#ec4899',           // pink-500
    'pink-light': '#f472b6',     // pink-400
    'fuchsia': '#d946ef',        // fuchsia-500
    'fuchsia-light': '#e879f9',  // fuchsia-400
    'rose': '#f43f5e',           // rose-500
    'rose-light': '#fb7185',     // rose-400
    
    // Reds & Oranges
    'red': '#ef4444',            // red-500
    'red-light': '#f87171',      // red-400
    'red-dark': '#dc2626',       // red-600
    'orange': '#f97316',         // orange-500
    'orange-light': '#fb923c',   // orange-400
    'orange-dark': '#ea580c',    // orange-600
    
    // Yellows & Ambers
    'amber': '#f59e0b',          // amber-500
    'amber-light': '#fbbf24',    // amber-400
    'yellow': '#eab308',         // yellow-500
    'yellow-light': '#facc15',   // yellow-400
    
    // Greens
    'lime': '#84cc16',           // lime-500
    'lime-light': '#a3e635',     // lime-400
    'green': '#22c55e',          // green-500
    'green-light': '#4ade80',    // green-400
    'green-dark': '#16a34a',     // green-600
    'emerald': '#10b981',        // emerald-500
    'emerald-light': '#34d399',  // emerald-400
    'teal': '#14b8a6',           // teal-500
    'teal-light': '#2dd4bf',     // teal-400
    
    // Neutrals & Grays
    'slate': '#64748b',          // slate-500
    'slate-light': '#94a3b8',    // slate-400
    'slate-dark': '#475569',     // slate-600
    'gray': '#6b7280',           // gray-500
    'gray-light': '#9ca3af',     // gray-400
    'gray-dark': '#4b5563',      // gray-600
    'zinc': '#71717a',           // zinc-500
    'zinc-light': '#a1a1aa',     // zinc-400
    'neutral': '#737373',        // neutral-500
    'neutral-light': '#a3a3a3',  // neutral-400
    'stone': '#78716c',          // stone-500
    'stone-light': '#a8a29e',    // stone-400
  };
  
  return colorMap[colorKey] || colorMap.primary;
};

export const getSectionColorTailwind = (colorKey: string): string => {
  const colorMap: Record<string, string> = {
    // Primary & Brand Colors
    'primary': 'bg-purple-500',
    'primary-light': 'bg-purple-400',
    'primary-dark': 'bg-purple-600',
    
    // Blues
    'blue': 'bg-blue-500',
    'blue-light': 'bg-blue-400',
    'blue-dark': 'bg-blue-600',
    'sky': 'bg-sky-500',
    'sky-light': 'bg-sky-400',
    'cyan': 'bg-cyan-500',
    'cyan-light': 'bg-cyan-400',
    
    // Purples & Violets
    'indigo': 'bg-indigo-500',
    'indigo-light': 'bg-indigo-400',
    'purple': 'bg-purple-500',
    'purple-light': 'bg-purple-400',
    'violet': 'bg-violet-500',
    'violet-light': 'bg-violet-400',
    
    // Pinks & Roses
    'pink': 'bg-pink-500',
    'pink-light': 'bg-pink-400',
    'fuchsia': 'bg-fuchsia-500',
    'fuchsia-light': 'bg-fuchsia-400',
    'rose': 'bg-rose-500',
    'rose-light': 'bg-rose-400',
    
    // Reds & Oranges
    'red': 'bg-red-500',
    'red-light': 'bg-red-400',
    'red-dark': 'bg-red-600',
    'orange': 'bg-orange-500',
    'orange-light': 'bg-orange-400',
    'orange-dark': 'bg-orange-600',
    
    // Yellows & Ambers
    'amber': 'bg-amber-500',
    'amber-light': 'bg-amber-400',
    'yellow': 'bg-yellow-500',
    'yellow-light': 'bg-yellow-400',
    
    // Greens
    'lime': 'bg-lime-500',
    'lime-light': 'bg-lime-400',
    'green': 'bg-green-500',
    'green-light': 'bg-green-400',
    'green-dark': 'bg-green-600',
    'emerald': 'bg-emerald-500',
    'emerald-light': 'bg-emerald-400',
    'teal': 'bg-teal-500',
    'teal-light': 'bg-teal-400',
    
    // Neutrals & Grays
    'slate': 'bg-slate-500',
    'slate-light': 'bg-slate-400',
    'slate-dark': 'bg-slate-600',
    'gray': 'bg-gray-500',
    'gray-light': 'bg-gray-400',
    'gray-dark': 'bg-gray-600',
    'zinc': 'bg-zinc-500',
    'zinc-light': 'bg-zinc-400',
    'neutral': 'bg-neutral-500',
    'neutral-light': 'bg-neutral-400',
    'stone': 'bg-stone-500',
    'stone-light': 'bg-stone-400',
  };
  
  return colorMap[colorKey] || colorMap.primary;
};
